import { PropsWithChildren, ReactElement } from "react";

interface IProps {
  loading: boolean;
  noData: boolean;
}

export const ComparatorWrapper = ({
  children,
  loading,
  noData,
}: PropsWithChildren<IProps>): ReactElement | null => {
  if (loading) {
    return null;
  }
  if (noData) {
    return null;
  }
  return <>{children}</>;
};
